var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 6.6h-1.4c-.4 0-.9-.2-1.2-.5l-1-1c-.7-.7-1.6-1.1-2.6-1.1h-5.6c-1 0-1.9.4-2.6 1.1l-1 1c-.3.3-.8.5-1.2.5H7c-2.8 0-5 2.2-5 5V23c0 2.8 2.2 5 5 5h18c2.8 0 5-2.2 5-5V11.6c0-2.8-2.2-5-5-5M28 23c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V11.6c0-1.7 1.3-3 3-3h1.4c1 0 1.9-.4 2.6-1.1l1-1c.3-.3.8-.5 1.2-.5h5.6c.4 0 .9.2 1.2.5l1 1c.7.7 1.6 1.1 2.6 1.1H25c1.7 0 3 1.3 3 3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
  clipRule: "evenodd"
})));
export default SvgCamera;